export enum AppView {
  Desktop = 'desktop',
  Mobile = 'mobile',
  Tablet = 'tablet',
}
